import { render, staticRenderFns } from "./question-content.vue?vue&type=template&id=c7cac366&scoped=true"
import script from "./question-content.vue?vue&type=script&lang=js"
export * from "./question-content.vue?vue&type=script&lang=js"
import style0 from "./question-content.vue?vue&type=style&index=0&id=c7cac366&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cac366",
  null
  
)

export default component.exports